import { Refresh, SaveAltSharp } from '@material-ui/icons';
import { csvFormulaInjectionSanitizer } from '../../../../../../../../../utilities/csvUtils';
import { withStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import Events from '../../../../../../../../../utilities/EventEmitter';
import StyledTooltip from '../../../../../StyledTooltip';
import appConstants from '../../../../../../../../../appConstants';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  iconStyle: {
    padding: 12,
    color: theme.iconColor,
    cursor: 'pointer'
  },
  headerControlsContainer: {
    display: 'flex',
    alignItems: 'center'
  }
});
const PickupInfoGridControls = ({
  classes,
  loadShipmentsData,
  gridInfo,
}) => {
  const [gridApi, setGridApi] = useState(null);
  useEffect(() => {
    Events.on('setGridApi', onSetGridApi);
    return () => {
      Events.off('setGridApi', onSetGridApi);
    };
  }, []);

  const onSetGridApi = ({ api, gridName }) => {
    setGridApi({ api, gridName });
  };
  const exportCSV = () => {
    if (gridApi?.api) {
      const params = {
        fileName: gridApi.gridName,
        processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
      };
      gridApi.api.exportDataAsCsv(params);
    }
  };
  return (
    <div className={classes.headerControlsContainer}>
      <StyledTooltip title="Export Data">
        <SaveAltSharp className={classes.iconStyle} onClick={exportCSV} />
      </StyledTooltip>
      {gridInfo.gridStatus === appConstants.GRID_STATUS.ERROR && (
        <StyledTooltip title="Retry">
          <Refresh onClick={loadShipmentsData} className={classes.iconStyle} />
        </StyledTooltip>
      )}
      <ClearAllFilterButton gridApi={gridApi?.api}/>
    </div>
  );
};

export default withStyles(styles)(PickupInfoGridControls);
